<template>
	<div class="inner with-content top-content">
		<a v-bind:href="link" class="go-back">
			<SvgIcon icon="arrow-back" />
		</a>

		<div class="headline">
			<h1>{{ title }}</h1>
			<p v-if="subtitle">{{ subtitle }}</p>

			<slot name="actions">
				
			</slot>
		</div>

	</div>
</template>

<script>
	import SvgIcon from './Svg.vue';
	export default {
		components:{
			SvgIcon
		},
		props: [
			'title',
			'subtitle',
			'link'
		]
	}
</script>